const APP_CONFIG = JSON.parse(localStorage.getItem('appConfig'));
import httpHelper from '../../../../utils/httpHelper';
const service = {
  async getEmployeesWithSearchAll(data) {
    const endPoint = `kv/employee/searchAll`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      { ...data },
      'Bearer',
    );
    return result;
  },
  async getAllCardEventByEmployeeId(id, params) {
    const endPoint = `kv/card-event/findAllEmployeeIdAndTimeBetween/${id}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },
  async getCardEventsByEmployeeId(id, params) {
    const endPoint = `kv/card-event/findByEmployeeIdAndTimeBetween/${id}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },
};
export default service;
